import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { getMetaForPath } from "../seo/pageMeta";

/**
 * Mounted once inside Layout. Resolves the current pathname to its metadata
 * and renders the tags. One mount point means page components stay untouched
 * and there is a single place to edit titles and descriptions.
 */
export default function RouteSeo() {
  const { pathname } = useLocation();
  // Blog posts set their own title, description and Open Graph tags (BlogDetailPage.jsx)
  // and ship them in static HTML (scripts/blog-prerender.mjs). The site-wide fallback
  // below would only add a second, conflicting description and og:title on top.
  if (pathname.startsWith("/blog/")) return null;
  return <Seo {...getMetaForPath(pathname)} />;
}
